import { c as _c } from "react/compiler-runtime";
import { translateInline } from '@/globals/translate/translateInline';
import { WebAPIEventResult } from '@/globals/webApiTypes/elements/WebAPIEvent';
import { DOPLink } from '@/uiComposites/interactive/DOPLink';
import { h4TextBlock } from '@/uiComposites/typography/headings';
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { stack } from '@/uiPrimitives/layout/stack';
import { textBlock, textInline, textStyle } from '@/uiPrimitives/typography/text';
import { dateTimeWithWeekdayFormatter, monthDayFormatter } from '@/globals/helpers/dateTimeFormatters';
import { secondaryButton } from '@/uiComposites/interactive/callToAction';
import { LinkKindIconInline } from '@/uiComposites/interactive/LinkKindIconInline';
import { addTestSelector } from '@/globals/testHelpers/testSelector';
import { ChevronLink } from '@/uiComposites/interactive/IconLink';
import { WebAPIEventsPage } from '@/globals/webApiTypes/pages/WebAPIEventsPage';
import { pluralize } from '@/globals/helpers/pluralize';
const EventResult = t0 => {
  const $ = _c(62);
  const {
    title,
    intro,
    link,
    meeting,
    hasMoreMeetings
  } = t0;
  let T0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== link || $[1] !== meeting.dateTime.from || $[2] !== meeting.dateTime.until || $[3] !== meeting.location.city || $[4] !== meeting.location.country || $[5] !== meeting.location.online || $[6] !== title) {
    t9 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const fromDate = new Date(meeting.dateTime.from);
      const untilDate = new Date(meeting.dateTime.until);
      let t10;
      if ($[17] !== meeting.location.city || $[18] !== meeting.location.country || $[19] !== meeting.location.online) {
        t10 = meeting.location.online ? translateInline({
          en: "Online",
          nl: "Online"
        }) : [meeting.location.city, meeting.location.country].filter(Boolean).join(", ");
        $[17] = meeting.location.city;
        $[18] = meeting.location.country;
        $[19] = meeting.location.online;
        $[20] = t10;
      } else {
        t10 = $[20];
      }
      const formattedLocation = t10;
      if (link == null) {
        t9 = null;
        break bb0;
      }
      if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = classes(stack({
          gap: "4 | betweenListItems"
        }));
        t8 = addTestSelector("uiEventsResultsList");
        $[21] = t7;
        $[22] = t8;
      } else {
        t7 = $[21];
        t8 = $[22];
      }
      T0 = DOPLink;
      t3 = "eventResult";
      t4 = link.href;
      let t11;
      let t12;
      if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = classes(stack({
          gap: "2 | h2"
        }));
        t11 = classes(stack({
          gap: "2 | h2"
        }));
        t12 = classes(textBlock({
          textDecorationLine: "none",
          fontWeight: "bold",
          capSize: "-1 | small"
        }));
        $[23] = t11;
        $[24] = t12;
        $[25] = t5;
      } else {
        t11 = $[23];
        t12 = $[24];
        t5 = $[25];
      }
      let t13;
      if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = classes(h4TextBlock({
          color: "positiveBlue",
          textDecorationLine: "underline"
        }));
        $[26] = t13;
      } else {
        t13 = $[26];
      }
      let t14;
      if ($[27] !== t13 || $[28] !== title) {
        t14 = <span className={t13}>{title}</span>;
        $[27] = t13;
        $[28] = title;
        $[29] = t14;
      } else {
        t14 = $[29];
      }
      t6 = <h2 className={t11}><span className={t12}>{monthDayFormatter.format(fromDate)}{formattedLocation !== "" && ` – ${formattedLocation}`}</span>{t14}</h2>;
      if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = classes(textBlock({
          textDecorationLine: "none",
          color: "positiveMuted",
          capSize: "-2 | smaller"
        }));
        $[30] = t1;
      } else {
        t1 = $[30];
      }
      t2 = dateTimeWithWeekdayFormatter.formatRange(fromDate, untilDate);
    }
    $[0] = link;
    $[1] = meeting.dateTime.from;
    $[2] = meeting.dateTime.until;
    $[3] = meeting.location.city;
    $[4] = meeting.location.country;
    $[5] = meeting.location.online;
    $[6] = title;
    $[7] = T0;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    T0 = $[7];
    t1 = $[8];
    t2 = $[9];
    t3 = $[10];
    t4 = $[11];
    t5 = $[12];
    t6 = $[13];
    t7 = $[14];
    t8 = $[15];
    t9 = $[16];
  }
  if (t9 !== Symbol.for("react.early_return_sentinel")) {
    return t9;
  }
  let t10;
  if ($[31] !== t1 || $[32] !== t2) {
    t10 = <p className={t1}>{t2}</p>;
    $[31] = t1;
    $[32] = t2;
    $[33] = t10;
  } else {
    t10 = $[33];
  }
  let t11;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = classes(textBlock({
      textDecorationLine: "none",
      fontVariantNumeric: "oldstyle-nums"
    }));
    $[34] = t11;
  } else {
    t11 = $[34];
  }
  let t12;
  if ($[35] !== intro || $[36] !== t11) {
    t12 = <p className={t11}>{intro}</p>;
    $[35] = intro;
    $[36] = t11;
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  let t13;
  if ($[38] !== T0 || $[39] !== t10 || $[40] !== t12 || $[41] !== t3 || $[42] !== t4 || $[43] !== t5 || $[44] !== t6) {
    t13 = <T0 data-link-type={t3} href={t4} className={t5}>{t6}{t10}{t12}</T0>;
    $[38] = T0;
    $[39] = t10;
    $[40] = t12;
    $[41] = t3;
    $[42] = t4;
    $[43] = t5;
    $[44] = t6;
    $[45] = t13;
  } else {
    t13 = $[45];
  }
  let t14;
  if ($[46] !== hasMoreMeetings || $[47] !== link.href) {
    t14 = hasMoreMeetings && <ChevronLink data-link-type="eventDetailLocatie" href={link.href} className={classes(textStyle({
      capSize: "-1 | small"
    }))}>{translateInline({
        en: "Multiple locations and dates",
        nl: "Meerdere locaties en datums"
      })}</ChevronLink>;
    $[46] = hasMoreMeetings;
    $[47] = link.href;
    $[48] = t14;
  } else {
    t14 = $[48];
  }
  let t15;
  if ($[49] !== meeting.isFull) {
    t15 = meeting.isFull === true && <p className={classes(textBlock({
      color: "positiveOrange",
      capSize: "-1 | small"
    }))}>{translateInline({
        en: "This event is fully booked",
        nl: "Deze bijeenkomst is volgeboekt"
      })}</p>;
    $[49] = meeting.isFull;
    $[50] = t15;
  } else {
    t15 = $[50];
  }
  let t16;
  if ($[51] !== meeting.isFull || $[52] !== meeting.signUpLink || $[53] !== title) {
    t16 = meeting.signUpLink?.href != null && meeting.isFull !== true && <DOPLink className={classes(secondaryButton({}))} data-link-type="eventDetailAanmelden" href={meeting.signUpLink.href} aria-label={`${translateInline({
      en: "Sign up for",
      nl: "Aanmelden voor"
    })} ${title}`}>{translateInline({
        en: "Sign up",
        nl: "Aanmelden"
      })}<LinkKindIconInline href={meeting.signUpLink.href} /></DOPLink>;
    $[51] = meeting.isFull;
    $[52] = meeting.signUpLink;
    $[53] = title;
    $[54] = t16;
  } else {
    t16 = $[54];
  }
  let t17;
  if ($[55] !== t13 || $[56] !== t14 || $[57] !== t15 || $[58] !== t16 || $[59] !== t7 || $[60] !== t8) {
    t17 = <div className={t7} {...t8}>{t13}{t14}{t15}{t16}</div>;
    $[55] = t13;
    $[56] = t14;
    $[57] = t15;
    $[58] = t16;
    $[59] = t7;
    $[60] = t8;
    $[61] = t17;
  } else {
    t17 = $[61];
  }
  return t17;
};
export const EventResults = t0 => {
  const $ = _c(16);
  const {
    eventResults
  } = t0;
  const t1 = eventResults?.length ?? 0;
  let t2;
  if ($[0] !== t1) {
    t2 = pluralize(t1, {
      none: translateInline({
        en: "No events found",
        nl: "Geen evenementen gevonden"
      }),
      single: translateInline({
        en: "event",
        nl: "evenement"
      }),
      plural: translateInline({
        en: "events",
        nl: "evenementen"
      })
    });
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const resultCountText = t2;
  let t3;
  let t4;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = classes(stack({
      gap: "7 | betweenH3Sections"
    }), textStyle({
      capLineHeight: "tight",
      fontVariantNumeric: "lining-nums"
    }));
    t4 = addTestSelector("uiResultList");
    t5 = classes(textBlock({
      capSize: "-1 | small",
      color: "positiveMuted"
    }));
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t3 = $[2];
    t4 = $[3];
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = addTestSelector("uiFilterResultCount");
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== eventResults.length) {
    t7 = (eventResults?.length ?? 0) > 0 && <><span className={classes(textInline({
        fontWeight: "bold"
      }))}>{eventResults?.length ?? 0}</span>{" "}</>;
    $[6] = eventResults.length;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== resultCountText || $[9] !== t7) {
    t8 = <div className={t5} role="status" {...t6}>{t7}{resultCountText}</div>;
    $[8] = resultCountText;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== eventResults) {
    t9 = eventResults.map(_temp);
    $[11] = eventResults;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t8 || $[14] !== t9) {
    t10 = <div className={t3} {...t4}>{t8}{t9}</div>;
    $[13] = t8;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  return t10;
};
function _temp(t0, index) {
  const {
    title,
    link,
    intro,
    meeting,
    hasMoreMeetings
  } = t0;
  return <EventResult title={title} intro={intro} link={link} meeting={meeting} hasMoreMeetings={hasMoreMeetings} key={index} />;
}